// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "rescript-classnames/src/Cn.bs.js";
import * as Card from "./Card.bs.js";
import * as BsCss from "../../bindings/BsCss.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as Regex from "../../utils/Regex.bs.js";
import * as $$String from "@rescript/std/lib/es6/string.js";
import * as Belt_Array from "@rescript/std/lib/es6/belt_Array.js";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as CatalogueCardList from "../pages/business/CatalogueCardList.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as CatalogueCardsSection from "../pages/business/CatalogueCardsSection.bs.js";
import * as CatalogueCobrandedSection from "../pages/business/CatalogueCobrandedSection.bs.js";

var smallTitle = Curry._1(BsCss.style, {
      hd: BsCss.fontSize(BsCss.rem(1.5)),
      tl: {
        hd: BsCss.lineHeight(BsCss.rem(2.0)),
        tl: {
          hd: BsCss.marginTop(BsCss.rem(1.0)),
          tl: /* [] */0
        }
      }
    });

var bottomContainer = Curry._1(BsCss.style, {
      hd: BsCss.marginBottom(BsCss.rem(1.0)),
      tl: {
        hd: BsCss.display("flex"),
        tl: {
          hd: BsCss.flexDirection("row"),
          tl: {
            hd: BsCss.flexWrap("wrap"),
            tl: /* [] */0
          }
        }
      }
    });

var Styles = {
  smallTitle: smallTitle,
  bottomContainer: bottomContainer
};

var spaceSlashRegex = /[\s\\]/g;

function getCardLists(search, cards) {
  return Belt_Option.mapWithDefault(search, {
              filteredCards: cards,
              similarCards: []
            }, (function (str) {
                var s = new RegExp($$String.lowercase_ascii(str.replace(Regex.specialRegex, "").replace(spaceSlashRegex, "")));
                return {
                        filteredCards: Belt_Array.keep(cards, (function (c) {
                                return s.test($$String.lowercase_ascii(c.searchableTerms.replace(Regex.specialRegex, "").replace(spaceSlashRegex, "")));
                              })),
                        similarCards: Belt_Array.keep(cards, (function (c) {
                                return s.test($$String.lowercase_ascii(c.similarTerms.replace(Regex.specialRegex, "").replace(spaceSlashRegex, "")));
                              }))
                      };
              }));
}

function CardSearchResults$SimilarResults(props) {
  var cardLists = props.cardLists;
  if (!(cardLists.filteredCards.length !== 0 && cardLists.similarCards.length !== 0)) {
    return null;
  }
  var skuDict = props.skuDict;
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx("h3", {
                      children: "Similar results",
                      className: smallTitle
                    }),
                JsxRuntime.jsx("div", {
                      children: Belt_Array.mapWithIndex(cardLists.similarCards, (function (i, card) {
                              return JsxRuntime.jsx(Card.make, {
                                          card: card,
                                          position: i + 1 | 0,
                                          skuDict: Caml_option.some(Belt_Option.getWithDefault(skuDict, {}))
                                        }, card.uid);
                            })),
                      className: Cn.make([
                            Belt_Option.getWithDefault(props.className, ""),
                            bottomContainer
                          ])
                    })
              ]
            });
}

var SimilarResults = {
  make: CardSearchResults$SimilarResults
};

function CardSearchResults(props) {
  var skuDict = props.skuDict;
  var cardLists = props.cardLists;
  if (cardLists.filteredCards.length !== 0) {
    return JsxRuntime.jsxs(JsxRuntime.Fragment, {
                children: [
                  JsxRuntime.jsx("h2", {
                        children: "Your search results",
                        className: CatalogueCardsSection.Styles.title
                      }),
                  JsxRuntime.jsx(CatalogueCardList.make, {
                        catalogue: cardLists.filteredCards,
                        skuDict: Caml_option.some(Belt_Option.getWithDefault(skuDict, {}))
                      }),
                  cardLists.similarCards.length !== 0 ? JsxRuntime.jsx(CardSearchResults$SimilarResults, {
                          cardLists: cardLists,
                          className: CatalogueCardList.Styles.container
                        }) : null
                ]
              });
  } else {
    return JsxRuntime.jsx(CatalogueCobrandedSection.make, {
                catalogue: props.swappableCards,
                isSearch: true,
                skuDict: Caml_option.some(Belt_Option.getWithDefault(skuDict, {}))
              });
  }
}

var SkuPresentation;

var make = CardSearchResults;

export {
  SkuPresentation ,
  Styles ,
  spaceSlashRegex ,
  getCardLists ,
  SimilarResults ,
  make ,
}
/* smallTitle Not a pure module */
